<div class="container-fluid">
    <div class="pb-wrapper bg-white p-4">




        <div class="row">
            <div class="col-xl-12 col-lg-12">
                <div class="all-leads mt-5">
                    <div class="card shadow mb-4">
                        <div class="card-body">
                            <h3 class="d-inline-block mr-3 mb-0" style="color: rgb(177, 128, 128);">Leads</h3>
                            <div class="table-responsive">
                                <table class="table table-hover agent-table">
                                    <thead>
                                        <tr>
                                            <th>S.NO</th>
                                            <th>LeadId/th>
                                            <th>Category</th>
                                            <th>Lead Type</th>
                                            <th>Created Date
                                            </th>
                                            <th>Customer Name</th>
                                            <th>Mobile Number</th>
                                            <th>EmailId</th>
                                            <th>Product</th>
                                            <th>Product Value</th>
                                            <th>Remarks</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                    
                                        <tr *ngFor="let item of filteredMembers">
                                            <td><input type="checkbox"></td>
                                            <td>{{ item.LeadID }}</td>
                                            <td>{{ item.Category }}</td>
                                            <td>{{ item.LeadType }}</td>
                                            <td>{{ item.CreatedDate }}</td>
                                            <td>{{ item.CustomerName }}</td>
                                            <td>{{ item.MobileNumber }}</td>
                                            <td>{{ item.EmailId }}</td>
                                            <td>{{ item.Product}}</td>
                                            <td>₹{{ item.ProductValue}}</td>
                                            <td>{{ item.Remarks}}</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
        </div>
    </div>
</div>